import i18n from '../locales';
import axios from 'axios';
import store from '../store';
import router from '../router';
//Imports para funcionalidades del mapa
import RouteDetailMapV2 from '../components/RouteDetailMapV2.vue';
import GoogleMapsApiLoader from 'google-maps-api-loader';
//Imports multiIdioma
import routeDetailModalEscl from '../locales/es-CL/routeDetailModal.json';
import routeDetailModalEsmx from '../locales/es-MX/routeDetailModal.json';
import routeDetailModalEsco from '../locales/es-CO/routeDetailModal.json';
import routeDetailModalEnus from '../locales/en-US/routeDetailModal.json';
import tripsEscl from '../locales/es-CL/trips.json';
import tripsEsmx from '../locales/es-MX/trips.json';
import tripsEsco from '../locales/es-CO/trips.json';
import tripsEnus from '../locales/en-US/trips.json';
import activitiesEscl from '../locales/es-CL/activities.json';
import activitiesEsmx from '../locales/es-MX/activities.json';
import activitiesEsco from '../locales/es-CO/activities.json';
import activitiesEnus from '../locales/en-US/activities.json';
import documentsEscl from '../locales/es-CL/documents.json';
import documentsEsmx from '../locales/es-MX/documents.json';
import documentsEsco from '../locales/es-CO/documents.json';
import documentsEnus from '../locales/en-US/documents.json';
import itemsEscl from '../locales/es-CL/items.json';
import itemsEsmx from '../locales/es-MX/items.json';
import itemsEsco from '../locales/es-CO/items.json';
import itemsEnus from '../locales/en-US/items.json';
import routeEventsEscl from '../locales/es-CL/routeEvents.json';
import routeEventsEsmx from '../locales/es-MX/routeEvents.json';
import routeEventsEsco from '../locales/es-CO/routeEvents.json';
import routeEventsEnus from '../locales/en-US/routeEvents.json';
//import para modales internos
import badgeStylesTrip from '../resources/badgeStylesTrip.json';
import showAlert from '../alert/alertHandler';
import showConfirmation from '@waypoint/vue-confirmation';
import showRouteDetailImage from './routeDetailModalImageHandler';
import moment from 'moment';
import { eventBus_routeDetailModal_routeDetailMap } from '../main';
//import testGps from './testGPS.json';
import RouteDetailDeliveryForm from '../components/RouteDetailDeliveryForm.vue';

export default {
  props: ['idRoute', 'events', 'type', 'idTrip'],
  components: { GoogleMapsApiLoader, RouteDetailMapV2, RouteDetailDeliveryForm },
  name: 'RouteBoardDetail',
  data() {
    return {
      isCollapseClicked: false,
      eventsInRoute: null,
      isRouteDetailBusy: false,
      isBusyMap: false,
      isBusyRecalculating: false,
      gapi: null,
      selectedRoute: null,
      currentTab: 'viajes',
      indexTab: 0,
      route: {
        name: '-',
        id: '-',
        driverName: '-',
        vehiclePlate: '-',
        status: '-',
      },
      imageBussy: false,
      imageSelect: '',
      mapStateTrip: '',
      isDisabledsubMotiveDocument: true,
      isDisabledMotiveDocument: true,
      isDisabledItem: false,
      canEditActivity: false,
      canEditDocument: false,
      actualAsignation: null,
      selectedTrip: null,
      selectedActivity: null,
      selectedDocument: null,
      selectedItem: null,
      fileActivity: null,
      fileBase64: null,
      showMap: false,
      showTrip: true,
      editActivity: false,
      isDisabledsubMotive: true,
      isDisabledMotive: true,
      parcial: false,
      isValidEditTrip: false,
      trips: [],
      tripChangeStatus: [],
      activities: [],
      documents: [],
      documentsUpdate: [],
      documentsData: [],
      items: [],
      motives: [],
      submotives: [],
      subMotivesActivity: [],
      subMotivesActivityDocuments: [],
      optionsSubMotive: [],
      itemsTotales: [],
      itemsData: [],
      eventsIO: [],
      zoneIOTripSelected: {},
      activityEditForm: {
        id: null,
        motive: null,
        state: null,
        submotive: null,
        documents: [],
      },
      documentEditForm: {
        id: null,
        motive: null,
        state: null,
        submotive: null,
        items: [],
      },
      statesActivity: [
        {
          id: 'PARTIALLYDONE',
          name: 'Realizado parcial',
        },
        {
          id: 'NOTDONE',
          name: 'No realizado',
        },
        {
          id: 'DONE',
          name: 'Realizado',
        },
      ],
      stateSpecial: [
        {
          id: 'NOTHANDLED',
          name: 'No gestionado',
        },
        {
          id: 'STARTED',
          name: 'Iniciado',
        },
      ],
      badgesTrip: badgeStylesTrip,
      //Badges utilizados para el estado de actividad,documento,item
      badges: {
        1: {
          background: '#FFFFFF',
          color: '#03475E',
        },
        2: {
          background: '#FFFFFF',
          color: '#E69C21',
        },
        3: {
          background: '#FFFFFF',
          color: '#C21F25',
        },
        4: {
          background: '#FFFFFF',
          color: '#52A145',
        },
        5: {
          background: '#FFFFFF',
          color: '#E69C21',
        },
      },
      dataAccess: null,
      autoRefreshTimer: 0,
      autoRefreshTimerLimit: 300,
      cancelTimer: false,
      secureZones: null,
      spotZones: null,
      historyRoute: [],
      autoRefreshTimerStatus: 0,
      autoRefreshTimerStatusLimit: 3,
      actualLocationVeh: null,
      actualLocationCargo: null,
      actualLocationGpsControl: null,
      listOfIdsCargo: [],
      listOfIdsGpsControl: [],
      isFilterClicked: false,
      isFilterShown: false,
      activeRealTimeVehicle: true,
      activeRealTimeCargo: true,
      activeRealTimeGpsControl: true,
      activeHistoryRoute: true,
      socket: {},
      endCounter: false,
      listVehiclesInfo: [],
      listCargoInfo: [],
      lastSignalGPS: null,
      showInfoCargo: false,
      infoCargoReady: true,
      infoVehicleReady: true,
      showInfoVehicle: false,
      vehicleListImei: [],
      canViewDeliveryForm: true,
      showRouteDetail: true,
      fullDataTripSelected: null,
      fullActivitySelected: null,
      totalImages: [],
      deleteImages: [],
      timeoutID: null,
      username: null,
      tabs: [],
    };
  },
  mounted() {
    this.$root.$on('bv::modal::hide', () => {
      setTimeout(() => {
        this.$destroy(); // cleanup in component
        this.$el.remove();
      }, 300);
    });
    i18n.setLocaleMessage('es-CL', {
      ...i18n.messages['es-CL'],
      routeDetailModal: routeDetailModalEscl,
      trips: tripsEscl,
      activities: activitiesEscl,
      documents: documentsEscl,
      items: itemsEscl,
      routeEvents: routeEventsEscl,
    });

    i18n.setLocaleMessage('es-MX', {
      ...i18n.messages['es-MX'],
      routeDetailModal: routeDetailModalEsmx,
      trips: tripsEsmx,
      activities: activitiesEsmx,
      documents: documentsEsmx,
      items: itemsEsmx,
      routeEvents: routeEventsEsmx,
    });

    i18n.setLocaleMessage('es-CO', {
      ...i18n.messages['es-CO'],
      routeDetailModal: routeDetailModalEsco,
      trips: tripsEsco,
      activities: activitiesEsco,
      documents: documentsEsco,
      items: itemsEsco,
      routeEvents: routeEventsEsco,
    });

    i18n.setLocaleMessage('en-US', {
      ...i18n.messages['en-US'],
      routeDetailModal: routeDetailModalEnus,
      trips: tripsEnus,
      activities: activitiesEnus,
      documents: documentsEnus,
      items: itemsEnus,
      routeEvents: routeEventsEnus,
    });
  },
  async created() {
    this.dataAccess = store.getters.dataAccess;
    this.username = store.getters.loggedUser.userName;
    this.autoRefreshTimer = await store.getters.routeDetailCounter;
    if (this.type != 'viewV2') {
      //const url = `${store.getters.urlWebSocketRealTimeRoute}`;
      const url = `${store.getters.urlWebSocketRealTimeRoute}?at=${store.getters.accessToken}`;
      this.socket = await new WebSocket(url);
      this.socket.onopen = () => {
        console.log('Websocket real time route connected.');
      };
      this.socketOnMessage();
    }
    this.autoRefresh();
    //Aqui empieza la logica.
    this.isRouteDetailBusy = true;
    await GoogleMapsApiLoader({
      libraries: ['places', 'marker'],
      apiKey: store.getters.apiKey,
    }).then((google) => {
      this.gapi = google;
    });
    if (this.type != 'viewV2') {
      this.tabs = ['viajes', 'actividades', 'documentos', 'items'];
      this.currentTab = 'viajes';
    } else {
      this.tabs = ['actividades', 'documentos', 'items'];
      this.currentTab = 'actividades';
    }
    this.createdMapStatus();
    await this.prepareData();
    await this.getMotives();
    await this.getSubMotives();
    this.isRouteDetailBusy = false;
    await this.getItems();
    await this.getItemsData();
  },
  beforeDestroy() {
    // Limpia el temporizador cuando el componente se destruya
    this.clearTimeout();
  },
  methods: {
    /**@author Jorge Pizarro Tapia
     * Metodo que refresca el contenido de la vista cada cierto tiempo.
     */
    autoRefresh() {
      if (this.cancelTimer) {
        return;
      }
      this.$root.$on('bv::modal::hide', () => {
        return;
      });
      if (this.autoRefreshTimer <= this.autoRefreshTimerLimit) {
        this.timeoutID = setTimeout(() => {
          this.autoRefreshTimer += 1;
          this.autoRefresh();
        }, 1000);
      } else {
        this.autoRefreshTimer = 0;
        this.refreshModal();
        this.autoRefresh();
      }
    },
    clearTimeout() {
      // Cancela el temporizador si está activo
      if (this.timeoutID !== null) {
        clearTimeout(this.timeoutID);
        console.log('Temporizador cancelado');
      }
    },
    async refreshModal() {
      this.isRouteDetailBusy = true;
      this.createdMapStatus();
      await this.prepareData();
      await this.getMotives();
      await this.getSubMotives();
      this.isRouteDetailBusy = false;
      await this.getItems();
      await this.getItemsData();
    },
    addWaypointSpots(secureZones, idSpots) {
      this.trips.forEach((trip, index) => {
        trip.waypoint = [];
        trip.widthRoute = 6;
        trip.routeColor = '#17a7d9';
        idSpots.push(trip.idOrigin);
        if (index == this.trips.length - 1) {
          idSpots.push(trip.idDestination);
        }
        if (secureZones) {
          secureZones.forEach((secureTrip) => {
            if (trip.idOrigin == secureTrip.idSpotOrigin && trip.idDestination == secureTrip.idSpotDestination) {
              trip.widthRoute = secureTrip.pathWidth <= 100 ? secureTrip.pathWidth / 10 : 15;
              trip.routeColor = '#AD20CE';
              secureTrip.waypoint.forEach((wayp) => {
                trip.waypoint.push({
                  location: {
                    lat: wayp.lat,
                    lng: wayp.lon,
                  },
                  stopover: false,
                });
              });
            }
          });
        }
      });
      return idSpots;
    },
    /**
     * Metodos para llamar al mapa de google
     */
    async showMapRoute() {
      if (this.trips.length > 0) {
        let pointSelected = null;
        this.showTrip = false;
        this.showMap = true;
        this.showInfoVehicle = false;
        this.showMapModal(pointSelected);
      } else {
        showAlert('Error', 'Aun no se terminan de cargar los viajes');
      }
    },
    /**
     * Metodos para llamar al mapa de google al hacer click en el origen
     */
    async showMapOrigin(trip) {
      let tripMap = trip;
      let pointOrigin = tripMap.coordinates.origin;
      this.showTrip = false;
      this.showMap = true;
      this.showInfoVehicle = false;
      this.showMapModal(pointOrigin);
    },
    /**
     * Metodos para llamar al mapa de google al hacer click en el destino
     */
    async showMapDestination(trip) {
      let tripMap = trip;
      let pointDestination = tripMap.coordinates.destination;
      this.showTrip = false;
      this.showMap = true;
      this.showInfoVehicle = false;
      this.showMapModal(pointDestination);
    },

    async showMapModal(pointSelected) {
      try {
        this.isBusyMap = true;
        await this.getRealTimeGPSVehicle();
        await this.listVehicleInfoByAssignation();
        let idSpots = [];
        //Si tengo zona segura nulo llamo al servicio
        if (this.secureZones == null) {
          this.secureZones = await this.getSecureRoutes();
        }
        //Preparo el listado de spots
        let listSpots = this.addWaypointSpots(this.secureZones, idSpots);
        listSpots = [...new Set(listSpots)];
        //Preparo el body para consultar por las zonas de los spots
        let bodySpot = {
          requireZone: true,
          spotIdList: listSpots,
        };
        //Si tengo spots de zonas nulo llamo al servicio
        if (this.spotZones == null) {
          this.spotZones = await this.getZonesByIdList(bodySpot);
        }
        this.isBusyMap = false;
        await this.waitForElm('#map');
        console.log('La ruta a enviar tiene id=' + this.route.id);

        eventBus_routeDetailModal_routeDetailMap.$emit('routeMapClicked', this.route);
        await this.$refs.map.setMap(this.gapi, this.trips, pointSelected, this.spotZones);
        if (this.historyRoute && this.actualLocationVeh) {
          await this.$refs.map.setMapRealTime(this.historyRoute, this.actualLocationVeh);
        }
      } catch (e) {
        console.log(e);
        this.showTrip = true;
        this.showMap = false;
      }
    },
    async getRealTimeGPSVehicle() {
      let listOfIdsVehicle = [];
      if (this.selectedRoute.assignations && this.selectedRoute.assignations.length > 0) {
        this.selectedRoute.assignations.forEach((assignation) => {
          if (assignation.state == 'ONGOING' && assignation.vehicle.id_vehicle_operaciones) {
            listOfIdsVehicle.push(assignation.vehicle.id_vehicle_operaciones);
            if (assignation.cargo) {
              this.listOfIdsCargo.push(assignation.cargo.id_vehicle_operaciones);
            }
            if (assignation.gpsControl) {
              this.listOfIdsGpsControl.push(assignation.gpsControl.id_vehicle_operaciones);
            }
          }
        });
        listOfIdsVehicle = [...new Set(listOfIdsVehicle)];
        this.listOfIdsCargo = [...new Set(this.listOfIdsCargo)];
        this.listOfIdsGpsControl = [...new Set(this.listOfIdsGpsControl)];

        let listOfIdsVehicle_socket = [...listOfIdsVehicle, ...this.listOfIdsCargo, ...this.listOfIdsGpsControl];
        console.log('idsenviar', listOfIdsVehicle_socket.toString());
        this.sendMessage(listOfIdsVehicle_socket.toString());
      }
      //listOfIdsVehicle = [95100];
      if (listOfIdsVehicle.length > 0) {
        await this.getHistoryRoute(listOfIdsVehicle);
      }
    },
    async waitForElm(selector) {
      return new Promise((resolve) => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(() => {
          if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });
    },
    /**
     * Metodo que construye el body para oslicitar el historial de la ruta
     * @param {Array} listOfImeis
     */
    async getHistoryRoute(listOfIdsVehicle) {
      console.log('Imeis ', listOfIdsVehicle);
      const urlHistoryRoute = `${store.getters.urlHistoryRoute}/history?vehicleIds=${listOfIdsVehicle.toString()}`;
      try {
        const sendHistoryRoute = await axios.get(urlHistoryRoute);
        await this.getDataHistoryRoute(sendHistoryRoute.data.data, listOfIdsVehicle);
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * Metodo que extrae el json de la url entregada, para obteer la data GPS y dibujarla en el mapa
     * @param {String} url
     */
    async getDataHistoryRoute(data, listOfIdsVehicle) {
      this.historyRoute = [];
      const startDateReal = this.selectedRoute.actualStartDate
        ? this.selectedRoute.actualStartDate
        : this.selectedRoute.startDate;
      const startDate = new Date(startDateReal).getTime();
      await listOfIdsVehicle.forEach((idVehicleOp) => {
        if (data[idVehicleOp] && data[idVehicleOp].length > 0) {
          data[idVehicleOp].forEach((location, index) => {
            if (startDate <= location.utc) {
              let body = {
                lat: location.latitud,
                lng: location.longitud,
              };
              if (index == data[idVehicleOp].length - 1) {
                this.actualLocationVeh = {
                  lat: location.latitud,
                  lon: location.longitud,
                  gpsData: {
                    cog: location.cog,
                    utc: location.utc,
                  },
                };
              }
              this.historyRoute.push(body);
            }
          });
        } else {
          console.log('No hay datos');
        }
      });
    },
    socketOnMessage() {
      this.socket.onmessage = async (event) => {
        // Se hace un parse de la data que llega a formato JSON
        let parsedMessage = JSON.parse(event.data);
        // Si los mensajes son distintos a undefined guarda la ubicacion entrante
        if (typeof parsedMessage !== 'undefined') {
          let pointSort = parsedMessage.data.sort((a, b) => a.gpsData.utc - b.gpsData.utc);
          pointSort.forEach((point) => {
            // Posicion de la carga
            try {
              if (this.listOfIdsCargo.includes(point.vehicleId)) {
                if (!this.actualLocationCargo) {
                  this.actualLocationCargo = point;
                  return;
                }

                if (this.actualLocationCargo != null && this.actualLocationCargo.gpsData.utc < point.gpsData.utc) {
                  this.actualLocationCargo = point;
                  return;
                }
              }
              if (this.listOfIdsGpsControl.includes(point.vehicleId)) {
                if (!this.actualLocationGpsControl) {
                  this.actualLocationGpsControl = point;
                  return;
                }

                if (
                  this.actualLocationGpsControl != null &&
                  this.actualLocationGpsControl.gpsData.utc < point.gpsData.utc
                ) {
                  this.actualLocationGpsControl = point;
                  return;
                }
              }
            } catch (err) {
              console.log(err);
            }

            if (this.actualLocationVeh != null && this.actualLocationVeh.gpsData.utc < point.gpsData.utc) {
              this.actualLocationVeh = point;
              this.historyRoute.push({
                lat: point.lat,
                lng: point.lon,
              });
            } else if (this.actualLocationVeh == null) {
              this.historyRoute.push({
                lat: point.lat,
                lng: point.lon,
              });
              this.actualLocationVeh = point;
            }
          });
          console.log('mensaje ', this.actualLocationVeh);
          console.log('mensaje cargo', this.actualLocationCargo);
          console.log('mensaje gps control', this.actualLocationGpsControl);
          await this.waitForElm('#map');
          if (this.actualLocationCargo) this.$refs.map.updateRealTimeCargo(this.actualLocationCargo);
          if (this.actualLocationGpsControl) this.$refs.map.updateRealTimeGpsControl(this.actualLocationGpsControl);
          this.$refs.map.addPointToRealTime(this.historyRoute, this.actualLocationVeh);
        }
      };
    },
    locationVehicleEnabled() {
      this.activeRealTimeVehicle = !this.activeRealTimeVehicle;
      this.$refs.map.enableRealTimeMarker(this.activeRealTimeVehicle);
    },
    locationCargoEnabled() {
      this.activeRealTimeCargo = !this.activeRealTimeCargo;
      this.$refs.map.enableRealTimeMarkerCargo(this.activeRealTimeCargo);
    },
    locationGpsControlEnabled() {
      this.activeRealTimeGpsControl = !this.activeRealTimeGpsControl;
      this.$refs.map.enableRealTimeMarkerGpsControl(this.activeRealTimeGpsControl);
    },
    historyRouteEnabled() {
      this.activeHistoryRoute = !this.activeHistoryRoute;
      this.$refs.map.enablePolyline(this.activeHistoryRoute);
    },
    /**
     * Metodo para enviar un mensaje por websocket, si el socket esta en un estado diferente a OPEN intentara esperar hasta que le permita enviar el mensaje o tirar un error
     * @param {*} message
     */
    async sendMessage(message) {
      if (this.socket.readyState !== this.socket.OPEN) {
        try {
          await this.waitForOpenConnection(this.socket);
          this.socket.send(message);
        } catch (err) {
          console.error(err);
        }
      } else {
        this.socket.send(message);
      }
    },
    /**
     * Este metodo se utiliza por si al momento de querer enviar el  mensaje, si este falla arroja un error de conexion
     * @returns
     */
    waitForOpenConnection() {
      return new Promise((resolve, reject) => {
        const maxNumberOfAttempts = 10;
        const intervalTime = 200;

        let currentAttempt = 0;
        const interval = setInterval(() => {
          if (currentAttempt > maxNumberOfAttempts - 1) {
            clearInterval(interval);
            reject(new Error('Maximum number of attempts exceeded.'));
          } else if (this.socket.readyState === this.socket.OPEN) {
            clearInterval(interval);
            resolve();
          }
          currentAttempt++;
        }, intervalTime);
      });
    },
    activateTrip() {
      this.showMap = false;
      this.showTrip = true;
    },
    createdMapStatus() {
      // Transforma los estados a triggers para el back
      // START,ARRIVE, END, POSTPONING,RESTART, CRON
      this.mapStateTrip = new Map();
      this.mapStateTrip.set('NOTSTARTED', 'NOTSTARTED');
      this.mapStateTrip.set('INTRANSIT', 'START');
      this.mapStateTrip.set('ATDESTINATION', 'ARRIVE');
      this.mapStateTrip.set('POSTPONED', 'POSTPONING');
      this.mapStateTrip.set('ENDED', 'END');
      this.mapStateTrip.set('RESTART', 'RESTART');
    },
    //Llamadas a los endpoint
    async getSecureRoutes() {
      const urlAlert = `${store.getters.urlAPI}/secureZone`;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const dataSecureRoutes = await axios.get(urlAlert, config);
        return dataSecureRoutes.data.data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async getZonesByIdList(body) {
      const urlAlert = `${store.getters.urlAPI}/api/spot/getByIdList`;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const dataZonesByList = await axios.post(urlAlert, body, config);
        return dataZonesByList.data.data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async getItemsData() {
      const urlRoute = `${store.getters.urlAPI}/api/itemData`;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const response = await axios.get(urlRoute, config);
        this.itemsData = response.data.data;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async getItems() {
      const urlRoute = `${store.getters.urlAPI}/api/item`;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const response = await axios.get(urlRoute, config);
        this.itemsTotales = response.data.data;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async getMotives() {
      const urlRoute = `${store.getters.urlAPI}/motive`;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const response = await axios.get(urlRoute, config);
        this.motives = response.data.data;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async getSubMotives() {
      const urlRoute = `${store.getters.urlAPI}/submotive`;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const response = await axios.get(urlRoute, config);
        this.submotives = response.data.data;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async getInTransitTripDetail() {
      const urlRoute = `${store.getters.urlAPI}/assignation/${this.actualAsignation}/inTransitTripDetail`;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const response = await axios.get(urlRoute, config);
        return response.data.data;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async fireEventTrip(trip) {
      const url = `${store.getters.urlAPI}/trip/${trip.id}/fireEvent/${this.mapStateTrip.get(
        trip.selectedStatus.code,
      )}`;
      const config = {
        headers: {
          'id-client': store.getters.clientId,
          Authorization: `Bearer ${store.getters.accessToken}`,
        },
      };
      const body = {};
      try {
        await axios.patch(url, body, config);
        this.tripChangeStatus = [];
        return true;
      } catch (e) {
        showAlert('Error', 'Se ha producido un error en operación');
        return false;
      }
    },
    async fireEventActivity() {
      const url = `${store.getters.urlAPI}/trip/${this.activitySelected.idTrip}/activity/fireEvent`;
      const config = {
        headers: {
          'id-client': store.getters.clientId,
          Authorization: `Bearer ${store.getters.accessToken}`,
        },
      };
      const body = this.prepareBody();
      try {
        await axios.patch(url, body, config);
        return true;
      } catch (e) {
        showAlert('Error', 'Se ha producido un error en operación');
        return false;
      }
    },
    async uploadImageS3() {
      let date = new Date(store.getters.dateToken);
      let now = new Date();
      let diff = Math.floor(Math.abs(now - date) / 1000 / 60);
      let rt = store.getters.refreshToken;
      let firstTime = store.getters.firstTimeRefresh;
      console.log(diff);
      if (firstTime || (diff >= 15 && rt)) {
        try {
          showAlert('Información', this.t('routeDetailModal.modalActivity.alertMessage.waitingForToken'));
          console.log('Obteniendo el nuevo Token');
          const url = `${store.getters.urlSimpleLogin}/refreshToken`;
          const body = {
            refreshToken: rt,
          };
          const response = await axios.post(url, body);
          console.log(response.data.AccessToken);
          store.commit('saveFirstTimeRefresh', false);
          store.commit('saveAccessToken', response.data.AccessToken);
          store.commit('saveDateToken', now);
        } catch (e) {
          console.log(e);
        }
      }
      const url = `${store.getters.urlImage}/simpleimageuploader/upload?project=lastmile&isBase64=true`;
      const config = {
        headers: {
          'id-client': store.getters.clientId,
          Authorization: `Bearer ${store.getters.accessToken}`,
        },
      };
      const body = {
        image: this.fileBase64,
      };
      try {
        const response = await axios.post(url, body, config);
        let image = {
          idActivity: this.activitySelected.id,
          urlImage: response.data.url,
          datePhotoTake: new Date(),
        };
        this.getNameImage(image);
        this.totalImages.push(image);
      } catch (e) {
        showAlert('Error', e.response.data);
      }
    },
    async getSignalGps() {
      const urlGps = `${store.getters.urlAPI}/api/vehicleDetailByIdList`;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const signalGPS = await axios.post(urlGps, this.vehicleListImei, config);
        console.log(signalGPS.data.data);
        return signalGPS.data.data;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    //---------------------------------------------------------------------------------------------//
    //Fin llamada a los endpoints
    /**@author Jorge Pizarro Tapia
     * Metodo inicial del modal.
     */
    async prepareData() {
      console.log('Tipo de modal ', this.type);
      if (this.type != 'viewV2') {
        this.eventsInRoute = await this.events;
        this.totalRows = this.eventsInRoute ? this.eventsInRoute.length : 0;
        this.setAliveEvents();
      }
      this.selectedRoute = await this.getRouteDetail();
      if (this.type != 'viewV2') {
        if (['ENDED', 'ENDEDINCOMPLETE'].includes(this.selectedRoute.state)) {
          await this.prepareZonesIO();
        }
        await this.populateEventByAssignation();
      }
      await this.setForm(this.selectedRoute);
      if (this.type == 'viewV2') {
        this.selectedTrip = this.idTrip;
        await this.loadActivities();
      }
    },
    /*
     * Prepara los datos de las fechas de entrada o salida de origen o destino
     */
    async prepareZonesIO() {
      this.eventsIO = this.selectedRoute.zonesIO;

      this.zoneIOTripSelected = {};
      this.selectedRoute.trips.forEach((trip) => {
        this.zoneIOTripSelected[trip.id] = {
          inDestination: undefined,
          outOrigin: undefined,
          editMode: true,
        };
      });

      Object.keys(this.eventsIO).forEach((trip) => {
        const tripID = Number(trip);

        this.eventsIO[tripID].show =
          this.eventsIO[tripID].outOrigin.length > 1 || this.eventsIO[tripID].inDestination.length > 1;
        this.eventsIO[tripID].hasSelectedEvents =
          this.eventsIO[tripID].selectedOutOrigin != null || this.eventsIO[tripID].selectedInDestination != null;
        this.eventsIO[tripID].editMode = !this.eventsIO[tripID].hasSelectedEvents;

        this.eventsIO[tripID].iconTimes = this.eventsIO[tripID].show && !this.eventsIO[tripID].hasSelectedEvents;

        let idTime = 0;
        this.eventsIO[tripID].outOriginTZ = this.eventsIO[tripID].outOrigin.map((date) => {
          return {
            id: idTime++,
            timelabel: this.formatDate(date, 'DD/MM/YY | HH:mm:ss'),
            original: date,
            epoch: moment(date).valueOf(),
          };
        });

        idTime = 0;
        this.eventsIO[tripID].inDestinationTZ = this.eventsIO[tripID].inDestination.map((date) => {
          return {
            id: idTime++,
            timelabel: this.formatDate(date, 'DD/MM/YY | HH:mm:ss'),
            original: date,
            epoch: moment(date).valueOf(),
          };
        });

        const tripRouteInfo = this.selectedRoute.trips.find((tripRoute) => tripID === tripRoute.id);
        const epochStartDate = moment(tripRouteInfo.actualStartDate).valueOf();
        const epochArrivalDate = moment(tripRouteInfo.actualArrivalDate).valueOf();

        const dates = this.eventsIO[tripRouteInfo.id];

        dates.outOriginTZ.forEach((dateOption) => {
          if (epochStartDate === dateOption.epoch) {
            this.zoneIOTripSelected[tripID]['outOrigin'] = dateOption.id;
          }
        });

        dates.inDestinationTZ.forEach((dateOption) => {
          if (epochArrivalDate === dateOption.epoch) {
            this.zoneIOTripSelected[tripID]['inDestination'] = dateOption.id;
          }
        });

        // Si no hay opciones, se marca con null
        if (dates.outOriginTZ.length === 0) this.zoneIOTripSelected[tripID]['outOrigin'] = null;
        if (dates.inDestinationTZ.length === 0) this.zoneIOTripSelected[tripID]['inDestination'] = null;
      });
      console.log('selected', this.zoneIOTripSelected);
      console.log('eventos', this.eventsIO);
    },
    /*
     * Guarda las fechas seleccionadas para entrada o salida
     */
    async saveSelectionZoneIO(trip) {
      const idOutOriginSelection = this.zoneIOTripSelected[trip].outOrigin;
      const idinDestinationSelection = this.zoneIOTripSelected[trip].inDestination;

      // undefined - no seleccionado
      // null - no habian datos para seleccionar
      if (idOutOriginSelection === undefined || idinDestinationSelection === undefined) {
        showAlert('Error', this.t('routeDetailModal.modalActivity.alertMessage.mustSelectBothDates'));
        return;
      }

      const payload = {
        outOrigin:
          idOutOriginSelection !== null
            ? this.eventsIO[trip].outOriginTZ.find((dateOption) => dateOption.id === idOutOriginSelection).epoch
            : null,
        inDestination:
          idinDestinationSelection !== null
            ? this.eventsIO[trip].inDestinationTZ.find((dateOption) => dateOption.id === idinDestinationSelection).epoch
            : null,
      };
      console.log(payload);

      // Refresh modal
      this.cancelTimer = true;
      this.isBusyRecalculating = true;

      await this.saveTripIO(trip, payload);

      this.cancelTimer = false;
      this.isBusyRecalculating = false;

      this.autoRefreshTimer = this.autoRefreshTimerLimit + 1;
      this.autoRefresh();
    },
    /*
     * Controla el boton de edicion para las fechas de entrada o salida
     */
    toggleButtonEditZoneIO(trip) {
      this.eventsIO[trip].editMode = !this.eventsIO[trip].editMode;
      this.eventsIO = Object.assign({}, this.eventsIO);
    },
    /*
     * Rellena el evento con informacion de la asignacion
     */
    async populateEventByAssignation() {
      this.selectedRoute.assignations.forEach((assig) => {
        this.eventsInRoute.forEach((event) => {
          // Agrega la carga si es que tiene una asignada
          if (assig.id === event.idAssignation) {
            event.cargoPlate = assig.cargo ? assig.cargo.plate : '-';
          }
        });
      });
    },
    setAliveEvents() {
      let today = Date.now();
      let aliveTime = today - 86400000;
      if (this.eventsInRoute) {
        this.eventsInRoute.forEach((event) => {
          let dateEvent = event.initEvent;
          if (dateEvent >= aliveTime) {
            event.stillAlive = true;
          } else {
            event.stillAlive = false;
          }
        });
      }
    },
    toogleCollapse(idCollapse) {
      this.isCollapseClicked = !this.isCollapseClicked;
      this.$root.$emit('bv::toggle::collapse', idCollapse);
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que se encarga de popular los datos de una ruta en el formulario.
     * @param {Route} route que sera leida desde el formulario.
     */
    async setForm(route) {
      if (route) {
        this.route.name = route.name;
        this.route.id = route.id;
        await this.loadTrips(route);
      }
    },
    formatDate(date, format) {
      //Si date es undefined, quiere decir que el conductor aun no ha empezado/llegado.
      if (date === undefined) {
        return ' -- | -- ';
      }
      return moment(date).format(format);
    },
    isRouteValidtoEditTrip() {
      if (this.selectedRoute.status === 7 || this.selectedRoute.status === 6) {
        this.isValidEditTrip = false;
      } else {
        this.isValidEditTrip = true;
      }
    },
    saveChangesTrip() {
      showConfirmation(
        this.t('common.modals.confirmacionTitulo'),
        this.t('routeDetailModal.routeDetailModal.confirmation'),
        () => {
          this.saveTrip();
        },
        this.t('common.cruds.aceptar'),
        this.t('common.cruds.cerrar'),
      );
    },
    /**
     * Metodo para guardar cambios al viaje
     */
    async saveTrip() {
      if (this.tripChangeStatus.length === 0) {
        await this.loadTrips(this.selectedRoute);
      }
      let response = false;
      for (let trip of this.tripChangeStatus) {
        response = await this.fireEventTrip(trip);
        if (!response) {
          break;
        }
      }
      if (response) {
        showAlert(
          this.t('routeDetailModal.alertMessages.success.title'),
          this.t('routeDetailModal.alertMessages.success.message'),
        );
        this.isRouteDetailBusy = true;
        await this.prepareData();
        this.isRouteDetailBusy = false;
      }
    },
    /**
     * Metodos para guardar actividad
     */
    saveChangesActivity() {
      showConfirmation(
        this.t('common.modals.confirmacionTitulo'),
        this.t('routeDetailModal.routeDetailModal.confirmationActivity'),
        () => {
          this.saveActivity();
        },
        this.t('common.cruds.aceptar'),
        this.t('common.cruds.cerrar'),
      );
    },
    async saveActivity() {
      if (this.validActivity()) {
        let response = false;
        response = await this.fireEventActivity();
        if (response) {
          showAlert(
            this.t('routeDetailModal.alertMessages.success.title'),
            this.t('routeDetailModal.alertMessages.success.message'),
          );
          this.isRouteDetailBusy = true;
          this.canEditActivity = false;
          await this.prepareData();
          await this.loadActivities();
          this.totalImages = [];
          this.deleteImages = [];
          this.isRouteDetailBusy = false;
        }
      }
    },
    /**
     * Metodo para validar que todos los campos se encuentren rellenados
     * @returns
     */
    validActivity() {
      if (this.activityEditForm.state === null) {
        showAlert('error', this.t('routeDetailModal.routeDetailModal.activityStatus'));
        return false;
      }
      if (
        this.activityEditForm.state.id === 'NOTDONE' ||
        (this.activityEditForm.state.id === 'PARTIALLYDONE' && this.activitySelected.documents.length === 0)
      ) {
        if (this.activityEditForm.motive == null && this.activityEditForm.submotive == null) {
          showAlert('error', this.t('routeDetailModal.routeDetailModal.activityMotive'));
          return false;
        }
      }

      for (let document of this.documentsData) {
        if (this.activityEditForm.state.id === 'PARTIALLYDONE' && document.statusSelected.id === 'PARTIALLYDONE') {
          if (document.items.length > 0 && !this.searchDocumentsUpdate(document.id)) {
            showAlert('error', this.t('routeDetailModal.routeDetailModal.activityUpdateDocument') + document.number);
            return false;
          }
        }
      }

      if (this.activityEditForm.state.id === 'PARTIALLYDONE') {
        return true;
      }

      if (this.checkAllDocumentDone()) {
        showAlert('error', this.t('routeDetailModal.routeDetailModal.documentsDone'));
        return false;
      }
      if (this.checkAllDocumentNotDone()) {
        showAlert('error', this.t('routeDetailModal.routeDetailModal.documentsNotDone'));
        return false;
      }
      return true;
    },
    searchDocumentsUpdate(id) {
      for (let document of this.documentsUpdate) {
        if (id === document.id) {
          return true;
        }
      }
      return false;
    },
    checkAllDocumentDone() {
      let countDocumentsDone = 0;
      for (let document of this.documentsData) {
        if (document.statusSelected && document.statusSelected.id === 'DONE') {
          countDocumentsDone++;
        }
      }
      return countDocumentsDone === this.documentsData.length && this.activityEditForm.state.id === 'PARTIALLYDONE';
    },
    checkAllDocumentNotDone() {
      let countDocumentsNotDone = 0;
      for (let document of this.documentsData) {
        if (document.statusSelected && document.statusSelected.id === 'NOTDONE') {
          countDocumentsNotDone++;
        }
      }
      return countDocumentsNotDone === this.documentsData.length && this.activityEditForm.state.id === 'PARTIALLYDONE';
    },
    prepareBody() {
      if (this.totalImages.length > 0) {
        let listNewImages = [];
        let isNewImage;
        //Obtengo un arreglo de las nuevas imagenes que se desean insertar
        this.totalImages.forEach((imageNoBack) => {
          isNewImage = true;
          this.activitySelected.images.forEach((image) => {
            if (imageNoBack.urlImage == image.urlImage) {
              isNewImage = false;
            }
          });
          if (isNewImage) {
            listNewImages.push(imageNoBack);
          }
        });
        this.totalImages = listNewImages;
      }
      let body = null;
      if (this.activityEditForm.state.id === 'DONE') {
        body = this.getBodyDone();
      } else if (this.activityEditForm.state.id === 'NOTDONE') {
        body = this.getBodyNotDone();
      } else if (this.activityEditForm.state.id === 'PARTIALLYDONE') {
        body = this.getBodyPartiallyDone();
      }
      return body;
    },
    getBodyPartiallyDone() {
      return {
        dataActivities: [
          {
            id: this.activitySelected.id,
            motive: this.activityEditForm.motive ? this.activityEditForm.motive.id : null,
            state: this.activityEditForm.state ? this.activityEditForm.state.id : '',
            submotive: this.activityEditForm.submotive ? this.activityEditForm.submotive.id : null,
            dataDocuments: this.processDocumentToSend(),
            images: this.totalImages.length > 0 ? this.totalImages : null,
            deleteImageIds: this.deleteImages.length > 0 ? this.deleteImages : null,
          },
        ],
        logStatus: {
          idConcept: 3,
        },
      };
    },
    processDocumentToSend() {
      let documentsToSend = [];
      for (let document of this.documentsData) {
        if (document.statusSelected) {
          let data = {
            id: document.id,
            state: document.statusSelected ? document.statusSelected.id : '',
            motive: this.documentEditForm.motive ? this.documentEditForm.motive.id : null,
            submotive: this.documentEditForm.submotive ? this.documentEditForm.submotive.id : null,
            dataItems: this.processItemToSend(document),
          };
          documentsToSend.push(data);
        }
      }
      return documentsToSend;
    },
    processItemToSend(document) {
      let itemsToSend = [];
      for (let item of this.items) {
        if (document.statusSelected.id === 'PARTIALLYDONE') {
          let data = {
            id: item.id,
            state: item.stateUpdate ? item.stateUpdate.id : item.state,
            motive: item.motiveUpdate ? item.motiveUpdate.id : null,
            submotive: item.subMotiveUpdate ? item.subMotiveUpdate.id : null,
            deliveredQuantity: item.actualQuantity ? item.actualQuantity : null,
          };
          itemsToSend.push(data);
        }
      }
      return itemsToSend;
    },
    getBodyDone() {
      return {
        dataActivities: [
          {
            id: this.activitySelected.id,
            state: this.activityEditForm.state ? this.activityEditForm.state.id : '',
            images: this.totalImages.length > 0 ? this.totalImages : null,
            deleteImageIds: this.deleteImages.length > 0 ? this.deleteImages : null,
          },
        ],
        logStatus: {
          idConcept: 3,
        },
      };
    },
    getBodyNotDone() {
      return {
        dataActivities: [
          {
            id: this.activitySelected.id,
            motive: this.activityEditForm.motive ? this.activityEditForm.motive.id : null,
            state: this.activityEditForm.state ? this.activityEditForm.state.id : '',
            submotive: this.activityEditForm.submotive ? this.activityEditForm.submotive.id : null,
            images: this.totalImages.length > 0 ? this.totalImages : null,
            deleteImageIds: this.deleteImages.length > 0 ? this.deleteImages : null,
          },
        ],
        logStatus: {
          idConcept: 3,
        },
      };
    },
    /**
     * Metodos para la edicion de actividad
     */
    //Este metodo reemplaza los submotivos dependiendo del motivo seleccionado
    onChangeMotive() {
      this.subMotivesActivity = [];
      for (let subMotive of this.submotives) {
        if (this.activityEditForm.motive.id === subMotive.idMotive) {
          this.subMotivesActivity.push(subMotive);
        }
      }
      if (this.subMotivesActivity.length == 0) {
        this.isDisabledsubMotive = true;
      } else {
        this.isDisabledsubMotive = false;
      }
    },
    //Este metodo reemplaza los submotivos dependiendo del motivo seleccionado
    onChangeMotiveDocument() {
      this.optionsSubMotive = [];
      this.documentEditForm.submotive = null;
      for (let subMotive of this.submotives) {
        if (this.documentEditForm.motive.id === subMotive.idMotive) {
          this.optionsSubMotive.push(subMotive);
        }
      }
      if (this.optionsSubMotive.length == 0) {
        this.isDisabledsubMotiveDocument = true;
      } else {
        this.isDisabledsubMotiveDocument = false;
      }
    },
    //Este metodo reemplaza los submotivos dependiendo del motivo seleccionado
    onChangeMotiveItem(item) {
      this.subMotivesActivityDocuments = [];
      for (let subMotive of this.submotives) {
        if (item.motiveUpdate.id === subMotive.idMotive) {
          this.subMotivesActivityDocuments.push(subMotive);
        }
      }
      item.optionsSubMotive = this.subMotivesActivityDocuments;
      if (item.optionsSubMotive.length === 0) {
        item.subMotiveUpdate = null;
      }
    },
    getNameForAllImage(activity) {
      if (activity.images.length > 0) {
        activity.images.forEach((image) => {
          this.getNameImage(image);
          this.totalImages.push(image);
        });
      }
    },
    getNameImage(image) {
      let arrayImage = image.urlImage.split('/');
      image.nameImage = arrayImage[arrayImage.length - 1];
    },
    deleteImage(deletedImage) {
      showConfirmation(
        this.t('common.modals.confirmacionTitulo'),
        this.t('routeDetailModal.routeDetailModal.confirmDelete'),
        () => {
          this.deleteImageAfterConfirm(deletedImage);
        },
        this.t('common.cruds.aceptar'),
        this.t('common.cruds.cerrar'),
      );
    },
    deleteImageAfterConfirm(deletedImage) {
      this.totalImages.forEach((image, index) => {
        if (image.urlImage == deletedImage.urlImage) {
          this.totalImages.splice(index, 1);
        }
      });
      this.activitySelected.images.forEach((imageInBack) => {
        if (imageInBack.urlImage == deletedImage.urlImage) {
          this.deleteImages.push(imageInBack.id);
        }
      });
    },
    /**
     * Metodo que prepara la imagen para enviarsela al endpoint
     */
    async uploadImage() {
      this.imageBussy = true;
      if (this.fileActivity) {
        if (this.totalImages.length <= 4) {
          this.fileBase64 = await this.readFileAsync(this.fileActivity);
          this.fileBase64 = this.fileBase64.split(',')[1];
          await this.uploadImageS3();
        } else {
          console.log(this.$refs.image);
          this.$refs.image.reset();
          showAlert('Error', this.t('routeDetailModal.routeDetailModal.limitImage'));
        }
      }
      this.fileActivity = null;
      this.imageBussy = false;
    },
    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
      });
    },
    /**
     * Metodo que habilita o deshabilita el motivo-submotivo-parical dependiendo del estado de la actividad
     */
    onChangeStatusActivity() {
      if (this.activityEditForm.state.id === 'NOTDONE') {
        if (this.subMotivesActivity.length == 0) {
          this.isDisabledsubMotive = true;
        } else {
          this.isDisabledsubMotive = false;
        }
        this.isDisabledMotive = false;
      } else {
        this.isDisabledsubMotive = true;
        this.isDisabledMotive = true;
      }
      if (this.activityEditForm.state.id === 'PARTIALLYDONE' && this.activitySelected.documents.length === 0) {
        if (this.subMotivesActivity.length == 0) {
          this.isDisabledsubMotive = true;
        } else {
          this.isDisabledsubMotive = false;
        }
        this.isDisabledMotive = false;
      }
      if (this.activityEditForm.state.id === 'PARTIALLYDONE') {
        if (this.subMotivesActivity.length == 0) {
          this.isDisabledsubMotive = true;
        }
        this.isDisabledDocument = false;
        this.parcial = true;
      } else {
        this.isDisabledDocument = true;
        this.parcial = false;
      }
    },
    /**
     * Checkea la cantidad de items para asignarle un estado al item, y asi desactivar o activar el dropdown de submotivo
     * @param {*} item
     * @returns
     */
    checkQuantity(item) {
      if (item.actualQuantity == 0) {
        item.stateUpdate = this.getStateNotDone();
        item.disabledSubMotive = false;
        return false;
      }
      if (item.actualQuantity != item.quantity) {
        item.stateUpdate = this.getStatePartiallyDone();
        item.disabledSubMotive = false;
        return false;
      }
      item.motiveUpdate = null;
      item.subMotiveUpdate = null;
      item.stateUpdate = this.getStateDone();
      item.disabledSubMotive = true;
      return true;
    },

    getStateDone() {
      return {
        id: 'DONE',
        name: 'Realizado',
      };
    },
    getStatePartiallyDone() {
      return {
        id: 'PARTIALLYDONE',
        name: 'Realizado parcial',
      };
    },
    getStateNotDone() {
      return {
        id: 'NOTDONE',
        name: 'No realizado',
      };
    },
    /**
     * Metodo que envia al modal de detalle de la imagen de cumplimiento
     * @param {Integer} routeID
     */
    showImage(image) {
      this.imageSelect = image.urlImage;
      showRouteDetailImage(this.imageSelect, this.selectedActivity);
    },
    showEdit(activity) {
      this.totalImages = [];
      this.deleteImages = [];
      this.selectedActivity = activity.id;
      this.setStatusActivity(activity);
      this.activitySelected = activity;
      this.getNameForAllImage(activity);
      this.documentsData = activity.documents;
      this.onChangeStatusActivity();
      this.setStatusDocument();
      this.canEditActivity = true;
    },
    setStatusActivity(activity) {
      //Verifica si el estado que viene corresponde a uno de los terminales
      for (const option of this.statesActivity) {
        if (option.id === activity.state.state) {
          this.activityEditForm.state = option;
          break;
        }
      }
      //Verifica si el estado que viene corresponde a alguno especial
      for (const option of this.stateSpecial) {
        if (option.id === activity.state.state) {
          this.activityEditForm.state = option;
          break;
        }
      }
      for (const option of this.motives) {
        if (option.id === activity.idMotive) {
          this.activityEditForm.motive = option;
          break;
        }
      }
      for (const subMotive of this.submotives) {
        if (activity.idSubmotive === subMotive.idMotive && activity.idSubmotive === subMotive.id) {
          this.activityEditForm.subMotive = subMotive;
        }
      }
    },
    // Fin edicion de actividad

    saveChangesDocuments() {
      showConfirmation(
        this.t('common.modals.confirmacionTitulo'),
        this.t('routeDetailModal.routeDetailModal.confirmationDocuments'),
        () => {
          this.saveDocument();
        },
        this.t('common.cruds.aceptar'),
        this.t('common.cruds.cerrar'),
      );
    },
    /**
     * Metodos para edicion de documentos
     */
    saveDocument() {
      if (this.validateItemsMotive()) {
        this.documentsUpdate.push(this.documentSelected);
        this.activateFrameActivity();
        this.processDocumentEdit();
      }
    },
    processDocumentEdit() {
      for (let document of this.documentsData) {
        if (this.documentSelected.id === document.id) {
          document.statusSelected = this.documentEditForm.state;
        }
      }
    },
    validMotiveAndSubmotive(item) {
      if (!item.motiveUpdate) {
        return true;
      }
      if (!item.subMotiveUpdate && item.optionsSubMotive.length > 0) {
        return true;
      }
      return false;
    },
    validateItemsMotive() {
      if (
        this.items.length === 0 &&
        this.documentEditForm.state.id === 'PARTIALLYDONE' &&
        this.documentEditForm.motive === null
      ) {
        showAlert('error', this.t('routeDetailModal.routeDetailModal.activityMotive'));
        return false;
      } else if (
        this.items.length === 0 &&
        this.documentEditForm.state.id === 'PARTIALLYDONE' &&
        this.documentEditForm.motive !== null
      ) {
        return true;
      }
      for (let item of this.items) {
        if (item.stateUpdate.id === 'PARTIALLYDONE' || item.stateUpdate.id === 'NOTDONE') {
          if (this.validMotiveAndSubmotive(item)) {
            showAlert('error', this.t('routeDetailModal.routeDetailModal.itemMotive') + item.name);
            return false;
          }
        }
      }
      if (this.checkAllItemsDone()) {
        showAlert('error', this.t('routeDetailModal.routeDetailModal.itemsDone'));
        return false;
      }
      if (this.checkAllItemsNotDone()) {
        showAlert('error', this.t('routeDetailModal.routeDetailModal.itemsNotDone'));
        return false;
      }
      return true;
    },
    checkAllItemsDone() {
      let countItemsDone = 0;
      for (let item of this.items) {
        if (item.stateUpdate && item.stateUpdate.id === 'DONE') {
          countItemsDone++;
        }
      }
      return countItemsDone === this.items.length && this.documentEditForm.state.id === 'PARTIALLYDONE';
    },
    checkAllItemsNotDone() {
      let countItemsNotDone = 0;
      for (let item of this.items) {
        if (item.stateUpdate && item.stateUpdate.id === 'NOTDONE') {
          countItemsNotDone++;
        }
      }
      return countItemsNotDone === this.items.length && this.documentEditForm.state.id === 'PARTIALLYDONE';
    },
    showEditDocument(document) {
      this.documentSelected = document;
      this.setStatusDocumentMain(document);
      this.items = document.items;
      this.processOptionsItems();
      this.setStatusItemGeneral();
      this.activateFrameDocument();
      this.onChangeStatusDocument();
    },
    setStatusDocumentMain(document) {
      for (let option of this.statesActivity) {
        if (option.id === document.statusSelected.id) {
          this.documentEditForm.state = option;
          break;
        }
      }
      for (let option of this.motives) {
        if (option.id === document.motive) {
          this.documentEditForm.motive = option;
          break;
        }
      }
      for (let subMotive of this.submotives) {
        if (document.motive === subMotive.idMotive && document.submotive === subMotive.id) {
          this.documentEditForm.subMotive = subMotive;
        }
      }
    },
    processOptionsItems() {
      for (let item of this.items) {
        item.optionsSubMotive = [];
        item.disabledSubMotive = false;
      }
    },
    setStatusItemGeneral() {
      for (let item of this.items) {
        for (let option of this.statesActivity) {
          if (option.id === item.state) {
            item.stateUpdate = option;
            break;
          }
        }
        for (let option of this.motives) {
          if (option.id === item.motive) {
            item.motiveUpdate = option;
            break;
          }
        }
        for (let subMotive of this.submotives) {
          if (item.motive === subMotive.idMotive && item.submotive === subMotive.id) {
            item.subMotiveUpdate = subMotive;
          }
        }
      }
    },
    activateFrameActivity() {
      this.canEditDocument = false;
      this.canEditActivity = true;
    },
    activateFrameDocument() {
      this.canEditDocument = true;
      this.canEditActivity = false;
    },
    onChangeStatusDocument() {
      if (this.documentEditForm.state.id === 'NOTDONE') {
        if (this.subMotivesActivityDocuments.length == 0) {
          this.isDisabledsubMotiveDocument = true;
        } else {
          this.isDisabledsubMotiveDocument = false;
        }
        this.isDisabledMotiveDocument = false;
      } else {
        this.isDisabledsubMotiveDocument = true;
        this.isDisabledMotiveDocument = true;
      }
      if (this.documentEditForm.state.id === 'PARTIALLYDONE' && this.documentSelected.items.length === 0) {
        if (this.subMotivesActivityDocuments.length == 0) {
          this.isDisabledsubMotiveDocument = true;
        } else {
          this.isDisabledsubMotiveDocument = false;
        }
        this.isDisabledMotiveDocument = false;
      }
      if (this.documentEditForm.state.id === 'PARTIALLYDONE') {
        // if (this.subMotivesActivityDocuments.length == 0) {
        //   this.isDisabledsubMotiveDocument = true;
        // } else {
        //   this.isDisabledsubMotiveDocument = false;
        // }
        // this.isDisabledMotiveDocument = false;
        this.isDisabledItem = true;
      } else {
        this.isDisabledItem = false;
      }
    },
    setStatusDocument() {
      for (let document of this.documentsData) {
        for (let option of this.statesActivity) {
          if (option.id === document.state) {
            document.statusSelected = option;
            break;
          }
        }
      }
      for (let document of this.documentsData) {
        this.onChangeDocument(document);
      }
    },
    onChangeDocument(document) {
      this.subMotivesActivity = [];
      if (document.statusSelected && document.statusSelected.id === 'PARTIALLYDONE') {
        document.isEdit = true;
      } else {
        document.isEdit = false;
      }
    },
    //Fin funcionalidades para edicion del modal

    //Funcionalidades de movimiento y visualizacion a lo largo del modal
    changeTab(navBar) {
      this.canEditActivity = false;
      this.canEditDocument = false;
      const previousTabIndex = this.tabs.indexOf(this.currentTab);
      this.currentTab = navBar;
      const currentTabIndex = this.tabs.indexOf(this.currentTab);
      this.indexTab = currentTabIndex;
      if (currentTabIndex > previousTabIndex) {
        this.loadByTab(navBar);
      }
    },
    async loadByTab(navBar) {
      this.isRouteDetailBusy = true;
      if (navBar === 'viajes') {
        await this.loadTrips(this.selectedRoute);
      } else if (navBar === 'actividades') {
        await this.loadActivities();
      } else if (navBar === 'documentos') {
        await this.loadDocuments();
      } else if (navBar === 'items') {
        await this.loadItemsDetails();
      }
      this.isRouteDetailBusy = false;
    },
    async loadActivities() {
      let tripSelected = this.trips.find((trip) => trip.id === this.selectedTrip);

      // Para abrir formulario de entrega de la actividad
      this.fullDataTripSelected = tripSelected;

      if (tripSelected.activities != undefined && tripSelected.activities.length > 0) {
        if (
          tripSelected.selectedStatus.code === 'ATDESTINATION' ||
          tripSelected.selectedStatus.code === 'ENDED' ||
          tripSelected.selectedStatus.code === 'NOTENDED'
        ) {
          this.editActivity = true;
        } else {
          this.editActivity = false;
        }
        this.activities = tripSelected.activities;
        this.activities.forEach((activity) => {
          activity.init = `[${this.startDateFormat(activity, tripSelected)}] - [${this.endDateFormat(
            activity,
            tripSelected,
          )}]`;
        });
      }
    },
    startDateFormat(activity, tripSelected) {
      if (activity.realStartDate) {
        return this.formatDate(activity.realStartDate, 'DD/MM/YY | HH:mm:ss');
      }
      return tripSelected.arrivalDestination.rawReal !== null
        ? this.formatDate(tripSelected.arrivalDestination.rawReal, 'DD/MM/YY | HH:mm:ss')
        : ' -- ';
    },
    endDateFormat(activity, tripSelected) {
      if (activity.realEndDate) {
        return this.formatDate(activity.realEndDate, 'DD/MM/YY | HH:mm:ss');
      }
      return tripSelected.actualEndDate !== null
        ? this.formatDate(tripSelected.actualEndDate, 'DD/MM/YY | HH:mm:ss')
        : ' -- ';
    },
    async loadDocuments() {
      let activitySelected = this.activities.find((act) => act.id === this.selectedActivity);
      this.documents = activitySelected.documents;
    },
    async loadItemsDetails() {
      let documentSelected = this.documents.find((doc) => doc.id === this.selectedDocument);
      this.items = documentSelected.items;
    },
    onTripClicked(item, index, event) {
      this.selectedActivity = null;
      this.selectedDocument = null;
      this.selectedItem = null;
      this.selectedTrip = item.id;
      this.currentPageActivity = 1;
      if (!['SVG', 'PATH'].includes(event.toUpperCase())) {
        this.changeTab('actividades');
      }
    },
    onActivityClicked(item, index, event) {
      this.selectedDocument = null;
      this.selectedItem = null;
      this.selectedActivity = item.id;
      this.currentPageDocument = 1;
      if (!['SVG', 'PATH'].includes(event.toUpperCase())) {
        this.changeTab('documentos');
      }
    },
    onDocumentClicked(item, index, event) {
      this.selectedItem = null;
      this.selectedDocument = item.id;
      this.currentPageItem = 1;
      if (!['SVG', 'PATH'].includes(event.toUpperCase())) {
        this.changeTab('items');
      }
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que recibe los trips de una ruta.
     * @param {Route} route la cual quiere sacar los trips.
     */
    async loadTrips(route) {
      this.trips = [];
      let tempTrips = [];
      let response = null;
      let assignVehicleDriver = new Map();
      this.isRouteValidtoEditTrip();
      if (route.assignations.length > 0 || route.assignations != null) {
        route.assignations.forEach((assign) => {
          assignVehicleDriver.set(assign.id, [assign.driver, assign.vehicle, assign.state, assign.cargo]);
        });
      }
      for (let trip of route.trips) {
        if (trip.idAssignation != undefined && trip.idAssignation != null) {
          if (trip.idAssignation != this.actualAsignation || this.actualAsignation == null) {
            this.actualAsignation = trip.idAssignation;
            response = await this.getInTransitTripDetail();
          }
        }
        const duration = new Date(trip.duration * 1000).toISOString().substr(11, 8);
        const actualDuration = new Date(trip.actualDuration * 1000).toISOString().substr(11, 8);

        const durationSplitted = duration.split(':');
        const actualDurationSplitted = actualDuration.split(':');

        const arrivalSeconds = this.dateToInteger(trip.startDate) + trip.drivingTime * 1000;
        const arrivalTime = new Date(arrivalSeconds);
        let [monthEstimate, dayEstimate, hourEstimate, minuteEstimate] = this.calculateEstimatedTime(response, trip);

        const month = arrivalTime.getMonth() + 1 < 10 ? '0' + (arrivalTime.getMonth() + 1) : arrivalTime.getMonth() + 1;
        const day = arrivalTime.getDate() < 10 ? '0' + arrivalTime.getDate() : arrivalTime.getDate();
        const hour = arrivalTime.getHours() < 10 ? '0' + arrivalTime.getHours() : arrivalTime.getHours();
        const minute = arrivalTime.getMinutes() < 10 ? '0' + arrivalTime.getMinutes() : arrivalTime.getMinutes();

        let [vehiclePlate, driverName, cargoPlate, showSelectStatus] = this.obtainDriverVehicle(
          assignVehicleDriver,
          trip,
          null,
          null,
          null,
          false,
        );

        let originName = null;
        let destinationName = null;
        //Valido que el origen exista y que posea un nombre
        if (trip.origin && trip.origin.name != null && trip.origin.name.split('_').length == 3) {
          let sizeOriginName = trip.origin.name.split('_')[0].split(',');
          if (sizeOriginName.length == 4 || sizeOriginName.length == 3) {
            originName = sizeOriginName[0] + ',' + sizeOriginName[1] + ',' + sizeOriginName[2];
          }
        }
        //Valido que el destino exista y que posea un nombre
        if (trip.destination && trip.destination.name != null && trip.destination.name.split('_').length == 3) {
          let sizeDestinationName = trip.destination.name.split('_')[0].split(',');
          if (sizeDestinationName.length == 4 || sizeDestinationName.length == 3) {
            destinationName = sizeDestinationName[0] + ',' + sizeDestinationName[1] + ',' + sizeDestinationName[2];
          }
        }
        const estimatedResult =
          response !== null && response.idTrip === trip.id
            ? dayEstimate + '/' + monthEstimate + ' ' + hourEstimate + ':' + minuteEstimate
            : '-';
        tempTrips.push({
          id: trip.id,
          tripOrder: this.dateToInteger(trip.startDate),
          origin: originName ? originName : trip.origin ? trip.origin.name : 'no encontrado',
          idOrigin: trip.origin ? trip.origin.id : 'no encontrado',
          originAddress: trip.origin ? trip.origin.address : 'no encontrado',
          originType: trip.origin ? trip.origin.type : 'no encontrado',
          departureOrigin: {
            sched: this.getDate(trip.startDate, 'complete'),
            rawSched: trip.startDate,
            real: trip.actualStartDate !== undefined ? this.getDate(trip.actualStartDate, 'complete') : null,
            rawReal: trip.actualStartDate,
          },
          isValidTrip: this.isValidTrip(trip),
          noDoneDocument: this.isNoDoneDocument(trip),
          parciallyDocument: this.isParciallyDocument(trip),
          destination: destinationName ? destinationName : trip.destination ? trip.destination.name : 'no encontrado',
          idDestination: trip.destination ? trip.destination.id : 'no encontrado',
          destinationAddress: trip.destination ? trip.destination.address : 'no encontrado',
          destinationType: trip.destination ? trip.destination.type : 'no encontrado',
          vehicle: vehiclePlate
            ? vehiclePlate
            : { vehiclePlate: this.t(`routeDetailModal.routeDetailModal.notAssigned`), state: 'NOTASSIGNED' },
          driver: driverName
            ? driverName
            : { driverName: this.t(`routeDetailModal.routeDetailModal.notAssigned`), state: 'NOTASSIGNED' },
          cargo: cargoPlate ? cargoPlate : { cargoPlate: '-', state: 'NOTASSIGNED' },
          actualStartDate: trip.actualStartDate !== undefined ? trip.actualStartDate : undefined,
          actualEndDate: trip.actualEndDate !== undefined ? trip.actualEndDate : undefined,
          arrivalDestination: {
            sched: day + '/' + month + ' ' + hour + ':' + minute,
            est:
              response === null && trip.status === 2
                ? this.t(`routeDetailModal.routeDetailModal.gettingLocation`)
                : estimatedResult,
            rawSched: trip.endDate,
            real:
              trip.actualDrivingTime > 0
                ? this.getDate(this.dateToInteger(trip.actualStartDate) + trip.actualDrivingTime * 1000, 'complete')
                : trip.actualArrivalDate
                ? this.getDate(trip.actualArrivalDate, 'complete')
                : null,
            rawReal:
              trip.actualDrivingTime > 0
                ? this.dateToInteger(trip.actualStartDate) + trip.actualDrivingTime * 1000
                : null,
            drivingTime: trip.drivingTime,
          },
          stayAtDestination: {
            rawSched: (parseInt(durationSplitted[0]) * 3600 + parseInt(durationSplitted[1]) * 60) * 1000,
            rawReal:
              trip.actualDuration === undefined || trip.actualDuration === null || trip.actualDuration === 0
                ? 0
                : (parseInt(actualDurationSplitted[0]) * 3600 + parseInt(actualDurationSplitted[1]) * 60) * 1000,
            sched: durationSplitted[0] + ':' + durationSplitted[1],
            real:
              trip.actualDuration === undefined || trip.actualDuration === null || trip.actualDuration === 0
                ? null
                : actualDurationSplitted[0] + ':' + actualDurationSplitted[1],
          },
          status: {
            id: trip.status,
            name: this.getStatusTrip(trip.status),
            code: trip.state,
          },
          actualStartDateSource: this.t(`routeDetailModal.routeDetailModal.source[${trip.actualStartDateSource - 1}]`),
          actualArrivalDateSource: this.t(
            `routeDetailModal.routeDetailModal.source[${trip.actualArrivalDateSource - 1}]`,
          ),
          optionStatus: this.getStatusTripRow(trip.state, trip.status),
          selectedStatus: {
            id: trip.status,
            name: this.getStatusTrip(trip.status),
            code: trip.state,
          },
          showSelectStatus: showSelectStatus,
          coordinates: {
            origin: {
              lat: trip.origin ? trip.origin.address.lat : 0,
              lng: trip.origin ? trip.origin.address.lon : 0,
            },
            destination: {
              lat: trip.destination ? trip.destination.address.lat : 0,
              lng: trip.destination ? trip.destination.address.lon : 0,
            },
          },
          lat: trip.lat,
          lon: trip.lon,
          activities: trip.activities ? trip.activities : '',
          extraData: trip.extraData,
        });
      }
      //Se ordena y se agregan los trips al formulario.
      this.trips = tempTrips.sort((a, b) => (a.tripOrder > b.tripOrder ? 1 : b.tripOrder > a.tripOrder ? -1 : 0));
    },
    calculateEstimatedTime(response, trip) {
      if (response !== null && response.idTrip === trip.id) {
        const arrivalEstimateSeconds = response.etaDateAnalized + response.estimatedTime * 1000;
        const arrivalEstimateTime = new Date(arrivalEstimateSeconds);
        const monthEstimate =
          arrivalEstimateTime.getMonth() + 1 < 10
            ? '0' + (arrivalEstimateTime.getMonth() + 1)
            : arrivalEstimateTime.getMonth() + 1;
        const dayEstimate =
          arrivalEstimateTime.getDate() < 10 ? '0' + arrivalEstimateTime.getDate() : arrivalEstimateTime.getDate();
        const hourEstimate =
          arrivalEstimateTime.getHours() < 10 ? '0' + arrivalEstimateTime.getHours() : arrivalEstimateTime.getHours();
        const minuteEstimate =
          arrivalEstimateTime.getMinutes() < 10
            ? '0' + arrivalEstimateTime.getMinutes()
            : arrivalEstimateTime.getMinutes();
        return [monthEstimate, dayEstimate, hourEstimate, minuteEstimate];
      }
      return [null, null, null, null];
    },
    obtainDriverVehicle(assignVehicleDriver, trip, driverName, vehiclePlate, cargoPlate, showSelectStatus) {
      if (trip.idAssignation != null) {
        let driverVehicle = assignVehicleDriver.get(trip.idAssignation);
        //Hay que pensar que ocurre con asignaciones que no poseen vehículos y driver
        if (driverVehicle != undefined) {
          vehiclePlate = {
            vehicle: assignVehicleDriver.get(trip.idAssignation)[1]
              ? assignVehicleDriver.get(trip.idAssignation)[1]
              : null,
            vehiclePlate: assignVehicleDriver.get(trip.idAssignation)[1]
              ? assignVehicleDriver.get(trip.idAssignation)[1].plate
              : null,
            state: assignVehicleDriver.get(trip.idAssignation)[2],
          };
          driverName = {
            driver: assignVehicleDriver.get(trip.idAssignation)[0]
              ? assignVehicleDriver.get(trip.idAssignation)[0]
              : null,
            driverName: assignVehicleDriver.get(trip.idAssignation)[0]
              ? this.transformWords(assignVehicleDriver.get(trip.idAssignation)[0].firstName) +
                ' ' +
                this.transformWords(assignVehicleDriver.get(trip.idAssignation)[0].lastName)
              : null,
            state: assignVehicleDriver.get(trip.idAssignation)[2],
          };

          let assigCargo = assignVehicleDriver.get(trip.idAssignation)[3];
          if (assigCargo)
            cargoPlate = {
              vehicle: assigCargo ? assigCargo : null,
              cargoPlate: assigCargo ? assigCargo.plate : null,
              state: assignVehicleDriver.get(trip.idAssignation)[2],
            };

          showSelectStatus = true;
        } else {
          vehiclePlate = null;
          driverName = null;
          cargoPlate = null;
        }
      }
      return [vehiclePlate, driverName, cargoPlate, showSelectStatus];
    },
    getExtraData(extraData) {
      if (extraData) {
        return Object.values(extraData).join(', ');
      } else {
        return '';
      }
    },
    isValidTrip(trip) {
      const today = new Date();
      const currentSeconds = today.getTime();
      const extraTime = 900000; //Tiempo extra (15 minutos).

      var isRouteInTime = null; //Verificador de tiempo de una ruta.
      if ('NOTSTARTED' == trip.state) {
        //Verifica que la hora actual no sobrepase la hora de inicio programada.
        const startLimit = new Date(trip.startDate);
        const startLimitSeconds = startLimit.getTime() + extraTime;

        //Si la hora actual sobrepasa la hora de inicio programada: hay retraso.
        if (currentSeconds > startLimitSeconds) {
          isRouteInTime = false;
        }
      }

      //Si el viaje esta en transito o ha terminado:
      if ('ENDED' == trip.state) {
        //Verifica que la hora iniciada no haya sobrepasado la hora de inicio programada.
        const startLimit = new Date(trip.startDate);
        const startLimitSeconds = startLimit.getTime() + extraTime;

        const initiatedTrip = new Date(trip.actualStartDate);
        const initiatedSeconds = initiatedTrip.getTime();

        //Si la hora iniciada sobrepaso la hora de inicio programada: hubo retraso.
        if (initiatedSeconds > startLimitSeconds) {
          isRouteInTime = false;
        }

        //Verifica que la hora terminada no haya sobrepasado la hora de termino programada.
        const endLimit = new Date(trip.endDate);
        const endLimitSeconds = endLimit.getTime() + extraTime;

        const terminatedTrip = new Date(trip.actualEndDate);
        const terminatedSeconds = terminatedTrip.getTime();

        //Si la hora terminada sobrepaso la hora de termino programada: hubo retraso.
        if (terminatedSeconds > endLimitSeconds) {
          isRouteInTime = false;
        }
      }
      if ('INTRANSIT' == trip.state) {
        //Verifica que la hora actual no sobrepase la hora de termino programada.
        const endLimit = new Date(trip.endDate);
        const endLimitSeconds = endLimit.getTime() + extraTime;

        //Si la hora actual sobrepasa la hora de termino programada: hay retraso.
        if (currentSeconds > endLimitSeconds) {
          isRouteInTime = false;
        } else {
          isRouteInTime = true;
        }
      }
      return isRouteInTime === null ? true : isRouteInTime;
    },
    isNoDoneDocument(trip) {
      for (let activity of trip.activities) {
        if (activity.documents != undefined && activity.documents.length > 0) {
          for (let document of activity.documents) {
            if (document.state === 'NOTDONE') {
              return true;
            }
          }
        } else {
          return activity.state === 'NOTDONE' ? true : false;
        }
      }
      return false;
    },
    isParciallyDocument(trip) {
      for (let activity of trip.activities) {
        for (let document of activity.documents) {
          if (document.state === 'PARTIALLYDONE') {
            return true;
          }
        }
      }
      return false;
    },
    checkAssignationStatus(routeStatus) {
      return routeStatus == 'TOBEASSIGNED' ? false : true;
    },

    /**@author Nicolas Sepulveda
     * Metodo para transformar las palabras a capitalize,
     * Ejemplo: jOSue = Josue
     * @param {String} words
     * @returns
     */
    transformWords(words) {
      let listWords = words.split(' ');
      let finalWord = '';
      listWords.forEach((word) => {
        if (word) {
          if (finalWord == '') {
            finalWord = this.capitalize(word);
          } else {
            finalWord = finalWord + ' ' + this.capitalize(word);
          }
        }
      });
      return finalWord;
    },
    capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que parsea la fecha en segundos.
     * @param {String} date es la fecha a parsear.
     * @returns la fecha en segundos.
     */
    dateToInteger(date) {
      const dateTemp = new Date(date);
      return dateTemp.getTime();
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que recibe un string timestamp para obtener fecha o la hora de esta.
     * @param {String} dateString, con formato timestamp (yyyy-mm-ddThh:mm:ss.ms).
     * @param {String} dateFlag, es lo que se quiere obtener del dateString.
     * @returns el valor deseado.
     */
    getDate(dateString, dateFlag) {
      const date = new Date(this.dateToInteger(dateString));

      const year = date.getFullYear();
      const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();

      //Si es fecha, retorna: dd-MM-yyyy
      if (dateFlag == 'date') {
        return day + '-' + month + '-' + year;
      }
      if (dateFlag == 'dateTime') {
        return day + '-' + month + '-' + year + ' ' + hour + ':' + minute + 'hrs.';
      }
      //Si es hora, retorna: hh:mm
      if (dateFlag == 'time') {
        return hour + ':' + minute;
      }
      //Si es completo, retorna: dd/MM hh:mm
      if (dateFlag == 'complete') {
        return day + '/' + month + ' ' + hour + ':' + minute;
      }
    },
    /**@author Jorge Pizarro Tapia
     * Obtiene la ruta en detalle desde el backend.
     * @returns el detalle de una ruta.
     */
    async getRouteDetail() {
      const urlRoute = `${store.getters.urlAPI}/route/${this.idRoute}`;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const routesPromise = await axios.get(urlRoute, config);
        console.log('Llego la ruta', routesPromise.data.data);
        return routesPromise.data.data;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    /**
     * Guarda los valores de fecha seleccionados de salida de origen y entrada de zona
     */
    async saveTripIO(trip, payload) {
      const urlRoute = `${store.getters.urlAPI}/trip/${trip}/zoneIO`;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const routesPromise = await axios.patch(urlRoute, payload, config);
        console.log('Termino update', routesPromise.data.data);
        return routesPromise.data.data;
      } catch (e) {
        showAlert('Error', this.t('routeDetailModal.modalActivity.alertMessage.failRecalcuation'));
        console.log(e);
        return null;
      }
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que muestra detalles de un trip.
     * @param {Trip} trip del cual se quiere ver en detalle.
     */
    viewDetail(trip) {
      trip.toggleDetails();
    },
    /**
     * Metodo para desplegar los
     * @param {*} status
     * @returns
     */
    getStatusTripRow(state, status) {
      let arrayStatus = [];
      let states = ['NOTSTARTED', 'INTRANSIT', 'ATDESTINATION', 'POSTPONED', 'ENDED', 'NOTENDED'];
      arrayStatus.push({
        id: status,
        name: this.getStatusTrip(status),
        code: state,
      });
      if (state === 'ENDED') {
        return arrayStatus;
      } else if (state === 'NOTENDED') {
        return arrayStatus;
      }
      if (state === 'ATDESTINATION') {
        arrayStatus.push({
          id: 5,
          name: this.getStatusTrip(5),
          code: 'ENDED',
        });
      } else if (state === 'INTRANSIT') {
        arrayStatus.push(
          {
            id: 3,
            name: this.getStatusTrip(3),
            code: 'ATDESTINATION',
          },
          {
            id: 4,
            name: this.getStatusTrip(4),
            code: 'POSTPONED',
          },
        );
      } else if (state === 'POSTPONED') {
        arrayStatus.push({
          id: 7,
          name: this.getStatusTrip(7),
          code: 'RESTART',
        });
      } else {
        arrayStatus.push({
          id: status + 1,
          name: this.t(`routeDetailModal.table.statusOptionsTrip[${status}]`), //como es un array no se le suma uno para ver el siguiente valor
          code: states[status],
        });
      }
      return arrayStatus;
    },
    activeFilter() {
      this.isFilterShown = !this.isFilterShown;
      this.isFilterClicked = !this.isFilterClicked;
    },
    /**
     * Metodo que captura los trips que recibieron cambios en sus estados
     * @param {} event
     * @param {*} trip
     */
    statusTripChanged(event, trip) {
      console.log('event', event);
      console.log('trip', trip);
      this.tripChangeStatus = this.tripChangeStatus.splice(this.tripChangeStatus.indexOf(trip.id), 1);
      this.tripChangeStatus.push(trip);
      console.log('array', this.tripChangeStatus);
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que traduce el id de estado de un trip a texto.
     * @param {Integer} statusTrip, es el id del estado actual de un trip.
     * @returns el estado de un trip en String.
     */
    getStatusTrip(statusTrip) {
      return this.t(`routeDetailModal.table.statusOptionsTrip[${statusTrip - 1}]`);
    },
    /**@author Jorge Pizarro Tapia
     * Verifica el estado del trip, para determinar si este esta concluido.
     * @param {Trip} item, es el trip a verificar.
     * @param {Object} type, el elemento debe ser de tipo "fila".
     * @returns el color de la fila.
     */
    rowTripStatus(item, type) {
      if (!item || type !== 'row') return;
      return item.status.code !== 'NOTSTARTED' ? 'highlightCabeceras table-info' : 'highlightCabeceras';
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que alterna el color del icono de un trip dependiendo de su estado.
     * @param {Trip} trip, es el trip a verificar
     * @returns el color asociado a su estado.
     */
    getColorIcon(trip) {
      //Si el trip no ha empezado: #acb3bf.
      //Si el trip ha empezado: #0096ca.
      return trip.item.status.code === 'NOTSTARTED' ? 'fill: #acb3bf;' : 'fill: #0096ca;';
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que permite interactuar con los .json de las traducciones.
     * @param {String} key, es el elemento del .json a utilizar.
     * @param {String} value, es la variable a insertar (en caso de que el elemento lo solicite).
     * @returns el resultado de la traduccion.
     */
    t(key, value) {
      return i18n.t(key, value);
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que cierra el modal.
     */
    close() {
      if (this.totalImages.length > 0 && this.totalImages.length != this.activitySelected.images.length) {
        showConfirmation(
          this.t('common.modals.confirmacionTitulo'),
          this.t('routeDetailModal.routeDetailModal.closeWithoutSave'),
          () => {
            this.closeModal();
          },
          this.t('common.cruds.aceptar'),
          this.t('common.cruds.cerrar'),
        );
      } else {
        this.closeModal();
      }
    },
    closeModal() {
      this.endCounter = true;
      if (this.type != 'viewV2') {
        this.socket.close();
      }
      this.$destroy();
      this.$el.remove();
      this.$bvModal.hide('route-detail-modal');
    },
    /**
     * Metodo que verifica el retraso de un trip dada la hora programada y la hora real.
     * @param {Object} tripDelay, es el objeto que contiene las horas a comparar.
     * @returns el estado del retraso del viaje.
     */
    checkDelay(tripDelay) {
      const dateReal = new Date(tripDelay.rawReal);
      const dateSched = new Date(tripDelay.rawSched);
      const diff = dateSched.getTime() - dateReal.getTime();

      if (diff >= 0) {
        return 'color: #52A145; fill: #52A145;'; //Verde.
      } else if (diff < 0 && diff >= -900000) {
        return 'color: #e69c21; fill: #e69c21;'; //Amarillo.
      } else {
        return 'color: #d90000; fill: #d90000;'; //Rojo.
      }
    },
    getNameEvent(typeEvent) {
      return this.t(`routeEvents.eventTypesOptions[${typeEvent}]`);
    },
    async goToAnotherPage(path) {
      await store.commit('saveShortCutPathOrigin', 'RouteBoard');
      this.$bvModal.hide('route-detail-modal');
      return router.push({ name: path });
    },
    async openInfoVehicle() {
      this.showInfoVehicle = !this.showInfoVehicle;
      if (this.showInfoVehicle) {
        this.infoVehicleReady = false;
        if (this.lastSignalGPS == null && this.vehicleListImei.length > 0) {
          this.lastSignalGPS = await this.getSignalGps();
        }
        this.listVehiclesInfo.forEach((vehicle) => {
          vehicle.signalGPS = this.t('routeDetailModal.vehicleEquipment.noSignal');
          vehicle.speedLimit = this.t('routeDetailModal.vehicleEquipment.speedLimit');
          vehicle.equipment = [this.t('routeDetailModal.vehicleEquipment.noEquipment')];
          vehicle.notification = [this.t('routeDetailModal.vehicleEquipment.noAlerts')];
          if (this.lastSignalGPS != undefined && this.lastSignalGPS.length > 0) {
            this.lastSignalGPS.forEach((signal) => {
              if (vehicle.id == signal.idVehicle) {
                if (signal.gpsEvent != null) {
                  vehicle.signalGPS = this.formatDate(signal.gpsEvent, 'DD/MM/YY HH:mm:ss');
                }
                if (signal.speedLimit != null) {
                  vehicle.speedLimit = signal.speedLimit + ' km/hr';
                }
                if (signal.equipment && signal.equipment.length > 0) {
                  let equipments = [];
                  signal.equipment.forEach((equipment) => {
                    equipments.push(this.transformWords(equipment));
                  });
                  vehicle.equipment = equipments;
                }
                if (signal.notification && signal.notification.length > 0) {
                  let notifications = [];
                  signal.notification.forEach((notification) => {
                    notifications.push(this.transformWords(notification));
                  });
                  vehicle.notification = notifications;
                }
              }
            });
          }
        });
        this.infoVehicleReady = true;
      }
    },
    async openInfoCargo() {
      this.showInfoCargo = !this.showInfoCargo;
      if (this.showInfoCargo) {
        this.infoCargoReady = false;
        if (this.lastSignalGPS == null && this.vehicleListImei.length > 0) {
          this.lastSignalGPS = await this.getSignalGps();
        }
        this.listCargoInfo.forEach((vehicle) => {
          vehicle.signalGPS = this.t('routeDetailModal.vehicleEquipment.noSignal');
          vehicle.speedLimit = this.t('routeDetailModal.vehicleEquipment.speedLimit');
          vehicle.equipment = [this.t('routeDetailModal.vehicleEquipment.noEquipment')];
          vehicle.notification = [this.t('routeDetailModal.vehicleEquipment.noAlerts')];
          if (this.lastSignalGPS != undefined && this.lastSignalGPS.length > 0) {
            this.lastSignalGPS.forEach((signal) => {
              if (vehicle.id == signal.idVehicle) {
                if (signal.gpsEvent != null) {
                  vehicle.signalGPS = this.formatDate(signal.gpsEvent, 'DD/MM/YY HH:mm:ss');
                }
                if (signal.speedLimit != null) {
                  vehicle.speedLimit = signal.speedLimit + ' km/hr';
                }
                if (signal.equipment && signal.equipment.length > 0) {
                  let equipments = [];
                  signal.equipment.forEach((equipment) => {
                    equipments.push(this.transformWords(equipment));
                  });
                  vehicle.equipment = equipments;
                }
                if (signal.notification && signal.notification.length > 0) {
                  let notifications = [];
                  signal.notification.forEach((notification) => {
                    notifications.push(this.transformWords(notification));
                  });
                  vehicle.notification = notifications;
                }
              }
            });
          }
        });
        this.infoCargoReady = true;
      }
    },
    checkObjectEmpty(obj) {
      return JSON.stringify(obj) === '{}';
    },
    /**
     * Metodo que pone cualquier otro vehículo que se haya seleccionado antes como false para que no se marque
     * @param {Object} vehicleInfo
     */
    clickIntoCard(vehicleInfo) {
      this.listVehiclesInfo.forEach((vehicle) => (vehicle.clicked = false));
      this.listCargoInfo.forEach((vehicle) => (vehicle.clicked = false));
      vehicleInfo.clicked = !vehicleInfo.clicked;
    },
    /**
     * Metodo que construye la lista de Vehiculos con su informacion de condcutor y trip vinculado
     */
    listVehicleInfoByAssignation() {
      let actualDriver = null;
      let actualVehicle = null;
      let actualCargo = null;
      let auxDriver = null;
      let auxVehicle = null;
      this.listVehiclesInfo = [];
      this.listCargoInfo = [];

      this.trips.forEach((trip) => {
        if (trip.vehicle.vehicle && trip.driver.driver) {
          actualVehicle = trip.vehicle.vehicle;
          actualDriver = trip.driver.driver;
          actualCargo = trip.cargo.vehicle;

          // Si existe carga asociada
          if (actualCargo) {
            let indexCargo = null;
            // Si el cargo ya esta en la lista
            let cargoExists = this.listCargoInfo.find((cargo, index) => {
              if (cargo.plate === actualCargo.plate) {
                indexCargo = index;
                return cargo;
              }
            });
            if (cargoExists) {
              // Agrega el conductor si no es el mismo
              this.listCargoInfo[indexCargo].drivers.forEach((driver) => {
                if (driver.id != actualDriver.id) {
                  this.listCargoInfo[indexCargo].drivers.push({
                    driver: trip.driver.driverName,
                    id: trip.driver.driver.id,
                  });
                }
              });
            } else {
              // Agrega la info de la carga
              this.vehicleListImei.push(actualCargo.id);
              this.listCargoInfo.push({
                id: actualCargo.id,
                plate: actualCargo.plate,
                clicked: false,
                drivers: [
                  {
                    id: trip.driver.driver.id,
                    driver: trip.driver.driverName,
                  },
                ],
              });
            }
          }

          //Si es el primer vehículo se inserta directamente
          if (auxVehicle == null) {
            this.vehicleListImei.push(actualVehicle.id);
            this.listVehiclesInfo.push({
              id: actualVehicle.id,
              plate: actualVehicle.plate,
              clicked: false,
              drivers: [
                {
                  driver: trip.driver.driverName,
                },
              ],
            });
          } else {
            let indexList = null;
            let existVehicle = this.listVehiclesInfo.find((vehicle, index) => {
              if (vehicle.plate == actualVehicle.plate) {
                indexList = index;
                return vehicle;
              }
            });
            //Si encuentra que existe el vehículo actual en la lista, se llenan sus datos internos
            if (existVehicle) {
              if (actualDriver.id != auxDriver.id) {
                this.listVehiclesInfo[indexList].drivers.push({
                  driver: trip.driver.driverName,
                });
              }
            }
            //Si no existe el vehículo en la lista se añade como nuevo objeto
            else {
              this.vehicleListImei.push(actualVehicle.id);
              this.listVehiclesInfo.push({
                id: actualVehicle.id,
                plate: actualVehicle.plate,
                clicked: false,
                drivers: [
                  {
                    driver: trip.driver.driverName,
                  },
                ],
              });
            }
          }
        }
        auxVehicle = actualVehicle;
        auxDriver = actualDriver;
      });
    },
    /**
     * Metodo que permite cambiar la vista del modal y abrir el formulario (si es que tiene)
     */
    openActivityDeliveryForm(activity) {
      this.fullActivitySelected = activity;

      // Propiedad que controla si se muestran solo las imagenes, segun el tipo de actividad, en la vista
      this.fullActivitySelected['showOnlyImages'] = ['COLLECTION', 'VISIT'].includes(this.fullActivitySelected.type);
      this.showRouteDetail = false;
    },
    /**
     * metodo que transforma el nombre de spot si es que es temporal
     * @param {Json} address
     * @param {String} nullCase
     * @returns
     */
    transformNameAddress(addressName, addressType, nullCase) {
      let destination;
      if (addressName) {
        if (addressType !== 'Temporal') {
          destination = addressName;
        } else {
          const splitAddress = addressName.split(',');
          destination = `${splitAddress[0]}, ${splitAddress[1]}`;
        }
      } else {
        destination = nullCase;
      }
      return destination;
    },
  },
  computed: {
    isNewMapEnabled() {
      const feature = this.$feature('newComponent');
      console.log("El nuevo fgeature esta activo ",feature);
      return feature && store.getters.clientId == 161;
    },
    itemsTrips() {
      return this.trips.map((t) => {
        let totalActivities = 0;
        let activitiesDone = 0;
        if (t.activities) {
          t.activities.forEach((activity) => {
            if (activity.state === 'DONE') {
              activitiesDone++;
            }
            totalActivities++;
          });
        }
        const origin = this.transformNameAddress(t.origin, t.originType, '-');
        const destination = this.transformNameAddress(t.destination, t.destinationType, '-');
        return {
          ...t,
          origin: origin,
          destination: destination,
          driver: t.driver ? t.driver : '-',
          vehicle: t.vehicle ? t.vehicle : '-',
          cargo: t.cargo ? t.cargo : '-',
          status: t.status,
          isLastTrip: this.trips.length > 0 ? this.trips[this.trips.length - 1].id === t.id : false,
          activityDone: [activitiesDone, totalActivities],
          extraData: t.extraData,
        };
      });
    },
    itemsActivities() {
      return this.activities.map((a) => {
        let motive = null;
        let submotive = null;
        if (
          (a.state == 'NOTDONE' || (a.state == 'PARTIALLYDONE' && a.documents && a.documents.length == 0)) &&
          a.motive != undefined &&
          a.submotive != undefined
        ) {
          motive = this.motives.find((mot) => mot.id == a.motive);
          submotive = this.submotives.find((smotive) => smotive.id == a.submotive);
        }
        return {
          ...a,
          route: '-',
          trip: '-',
          name: a.name ? a.name : '-',
          type: a.type ? a.type : 'DELIVERY',
          state: a.state ? { state: a.state, status: a.status } : '-',
          motive: motive ? motive.name : '-',
          submotive: submotive ? submotive.name : '-',
          idMotive: motive ? motive.id : 0,
          idSubmotive: submotive ? submotive.id : 0,
          urlImage: a.urlImage != undefined ? a.urlImage : null,
          showDeliveryForm:
            a.receiverLegalNumber ||
            a.receiverName ||
            a.images.length > 0 ||
            a.type == 'DELIVERY' ||
            ((a.type == 'COLLECTION' || a.type == 'VISIT') && a.images.length > 0),
        };
      });
    },
    itemDocuments() {
      return this.documents.map((d) => {
        let motive = null;
        let submotive = null;
        let itemsDone = 0;
        if (d.items && d.items.length > 0) {
          d.items.forEach((item) => {
            if (item.state == 'DONE') {
              itemsDone++;
            }
          });
        }
        if (
          (d.state == 'NOTDONE' || (d.state == 'PARTIALLYDONE' && d.items && d.items.length == 0)) &&
          d.motive != undefined &&
          d.submotive != undefined
        ) {
          motive = this.motives.find((mot) => mot.id == d.motive);
          submotive = this.submotives.find((smotive) => smotive.id == d.submotive);
        }
        return {
          ...d,
          route: '-',
          trip: '-',
          activity: '-',
          documentNumber: d.number,
          motive: motive ? motive.name : '-',
          submotive: submotive ? submotive.name : '-',
          state: d.state ? { state: d.state, status: d.status } : '-',
          items: d.items ? itemsDone + '/' + d.items.length : 0,
        };
      });
    },
    itemItems() {
      return this.items.map((i) => {
        let motive = null;
        let submotive = null;
        let code = null;
        let type = null;
        if (i.idItemData) {
          let itemDataSelected = this.itemsData.find((item) => item.id == i.idItemData);
          code = itemDataSelected ? itemDataSelected.code : null;
          let itemSelected = this.itemsTotales.find((itemT) => itemT.id == itemDataSelected.idItem);
          type = itemSelected ? itemSelected.name : null;
        }
        if ((i.state == 'NOTDONE' || i.state == 'PARTIALLYDONE') && i.motive != undefined && i.submotive != undefined) {
          motive = this.motives.find((mot) => mot.id == i.motive);
          submotive = this.submotives.find((smotive) => smotive.id == i.submotive);
        }
        return {
          ...i,
          document: i.idDocument,
          state: i.state ? { state: i.state, status: i.status } : '-',
          code: code ? code : '-',
          type: type ? type : '-',
          unitMeasure: i.unitMeasure || '-',
          quantityDone: i.actualQuantity,
          quantity: i.quantity || '-',
          motive: motive ? motive.name : '-',
          submotive: submotive ? submotive.name : '-',
        };
      });
    },
    rows() {
      if (this.currentTab === 'viajes') {
        return this.itemsTrips.length;
      } else if (this.currentTab === 'actividades') {
        return this.itemsActivities.length;
      } else if (this.currentTab === 'documentos') {
        return this.itemDocuments.length;
      } else if (this.currentTab === 'items') {
        return this.itemItems.length;
      }
    },
    isActivityTabEnabled() {
      return !!this.selectedTrip;
    },
    isDocumentTabEnabled() {
      return !!this.selectedTrip && !!this.selectedActivity;
    },
    isItemTabEnabled() {
      return !!this.selectedTrip && !!this.selectedActivity && !!this.selectedDocument;
    },
    tripDetailField() {
      const common = {
        thClass: 'text-center',
      };
      return [
        {
          key: 'tripIcon',
          tdClass: 'text-center',
          label: '',
          ...common,
        },
        {
          key: 'origin',
          tdClass: 'text-center',
          label: this.t('routeDetailModal.routeDetailModal.origin'),
          ...common,
        },
        {
          key: 'destination',
          tdClass: 'text-center',
          label: this.t('routeDetailModal.routeDetailModal.destination'),
          ...common,
        },
        {
          key: 'extraData',
          tdClass: 'text-center',
          label: this.t('routeDetailModal.routeDetailModal.extraField'),
          ...common,
        },
        {
          key: 'driver',
          tdClass: 'text-center',
          label: this.t('routeDetailModal.routeDetailModal.driverName'),
          ...common,
        },
        {
          key: 'vehicle',
          tdClass: 'text-center',
          label: this.t('routeDetailModal.routeDetailModal.vehiclePlate'),
          ...common,
        },
        {
          key: 'cargo',
          tdClass: 'text-center',
          label: this.t('routeDetailModal.routeDetailModal.cargoPlate'),
          ...common,
        },
        {
          key: 'status',
          tdClass: 'text-center',
          label: this.t('routeDetailModal.routeDetailModal.status'),
          ...common,
        },
        {
          key: 'activitiesDone',
          tdClass: 'text-center',
          label: this.t('routeDetailModal.routeDetailModal.activitiesDone'),
          ...common,
        },
        {
          key: 'actions',
          tdClass: 'text-center',
          label: this.t('routeDetailModal.routeDetailModal.action'),
          ...common,
        },
      ];
    },
    activitieDetailField() {
      const common = {
        thClass: 'text-center',
      };
      return [
        {
          key: 'name',
          tdClass: 'text-left',
          label: this.t('activities.tabla.cabeceras.name'),
          ...common,
        },
        {
          key: 'type',
          tdClass: 'text-left',
          label: this.t('activities.tabla.cabeceras.type'),
          ...common,
        },
        {
          key: 'init',
          tdClass: 'text-center',
          label: this.t('activities.tabla.cabeceras.init'),
          ...common,
        },
        {
          key: 'motive',
          tdClass: 'text-left',
          label: this.t('activities.tabla.cabeceras.motive'),
          ...common,
        },
        {
          key: 'submotive',
          tdClass: 'text-center',
          label: this.t('activities.tabla.cabeceras.submotive'),
          ...common,
        },
        {
          key: 'state',
          tdClass: 'text-center',
          label: this.t('activities.tabla.cabeceras.state'),
          ...common,
        },
        {
          key: 'actions',
          tdClass: 'text-center',
          label: this.t('routeDetailModal.routeDetailModal.action'),
          ...common,
        },
      ];
    },
    documentDetailField() {
      const common = {
        thClass: 'text-center',
      };
      return [
        {
          key: 'documentNumber',
          tdClass: 'text-left',
          label: this.t('documents.tabla.cabeceras.documentNumber'),
          ...common,
        },
        {
          key: 'motive',
          tdClass: 'text-left',
          label: this.t('documents.tabla.cabeceras.motive'),
          ...common,
        },
        {
          key: 'submotive',
          tdClass: 'text-center',
          label: this.t('documents.tabla.cabeceras.submotive'),
          ...common,
        },
        {
          key: 'state',
          tdClass: 'text-left',
          label: this.t('documents.tabla.cabeceras.state'),
          ...common,
        },
        {
          key: 'items',
          tdClass: 'text-center',
          label: this.t('documents.tabla.cabeceras.items'),
          ...common,
        },
        {
          key: 'actions',
          tdClass: 'text-center',
          label: this.t('routeDetailModal.routeDetailModal.action'),
          ...common,
        },
      ];
    },
    itemDetailField() {
      const common = {
        thClass: 'text-center',
      };
      return [
        {
          key: 'name',
          tdClass: 'text-left',
          label: this.t('items.tabla.cabeceras.name'),
          ...common,
        },
        {
          key: 'type',
          tdClass: 'text-left',
          label: this.t('items.tabla.cabeceras.type'),
          ...common,
        },
        {
          key: 'code',
          tdClass: 'text-left',
          label: this.t('items.tabla.cabeceras.code'),
          ...common,
        },
        {
          key: 'quantityDone',
          tdClass: 'text-left',
          label: this.t('items.tabla.cabeceras.quantityDone'),
          ...common,
        },
        {
          key: 'quantity',
          tdClass: 'text-left',
          label: this.t('items.tabla.cabeceras.quantity'),
          ...common,
        },
        {
          key: 'motive',
          tdClass: 'text-left',
          label: this.t('items.tabla.cabeceras.motive'),
          ...common,
        },
        {
          key: 'submotive',
          tdClass: 'text-center',
          label: this.t('items.tabla.cabeceras.submotive'),
          ...common,
        },
        {
          key: 'state',
          tdClass: 'text-left',
          label: this.t('items.tabla.cabeceras.state'),
          ...common,
        },
      ];
    },
    eventDetailField() {
      const common = {
        thClass: 'text-center',
      };
      return [
        {
          key: 'nameEvent',
          tdClass: 'text-center',
          label: this.t('routeEvents.eventsInRoute.nameEvent'),
          ...common,
        },
        {
          key: 'initEvent',
          tdClass: 'text-center',
          label: this.t('routeEvents.eventsInRoute.initEvent'),
          ...common,
        },
        {
          key: 'nameOrigin',
          tdClass: 'text-center',
          label: this.t('routeEvents.eventsInRoute.nameOrigin'),
          ...common,
        },
        {
          key: 'nameDestination',
          tdClass: 'text-center',
          label: this.t('routeEvents.eventsInRoute.nameDestination'),
          ...common,
        },
        {
          key: 'plate',
          tdClass: 'text-center',
          label: this.t('routeEvents.eventsInRoute.plate'),
          ...common,
        },
        {
          key: 'driver',
          tdClass: 'text-center',
          label: this.t('routeEvents.eventsInRoute.driver'),
          ...common,
        },
        {
          key: 'cargoPlate',
          tdClass: 'text-center',
          label: this.t('routeEvents.eventsInRoute.cargoPlate'),
          ...common,
        },
        {
          key: 'shortcut',
          tdClass: 'text-center',
          label: this.t('routeEvents.eventsInRoute.shortcut'),
          ...common,
        },
      ];
    },
  },
};
